<template>
  <div class="publication">
    <h3 class="publication-title">
      {{ title }} 
      <span class="publication-title-dates">{{ capitalizeFirstChar(parutionDate) }}</span>
    </h3>
    <p class="publication-link">
      <a :href="link" target="blank">{{ link }}</a>
    </p>
  </div>
</template> 

<script>
  import useFormat from "@/helpers/format"

  export default {
    name: "Publication",
    props: {
      title: { type: String, required: true },
      parutionDate: { type: String, required: true },
      authors: { type: Array, required: true },
      link: { type: String, required: true}
    },
    setup() {
      const { capitalizeFirstChar } = useFormat

      return { capitalizeFirstChar: capitalizeFirstChar }
    }
  }
</script>

<style lang="scss" scoped>
  .publication {
    color: var(--contrast-color);
    border: 1px solid var(--main-color-accent);
    padding: 0 2rem;
    margin: 1rem 0;

    &-title {
      color: var(--main-color-accent);

      &-dates {
        display: block;
        color: var(--contrast-color);
        font-weight: normal;
        font-style: italic;
      }
    }

    &-link {
      text-align: right;

      a, a:hover, a:visited, a:active, a:focus, a:target {
        color: white;
        text-decoration: none;
      }
    }
  }
  
  @include desktop {
    .home-block {
      &-title { font-size: 3.5rem; }
    }
  }

  @include mobile {
    .professional-experience {
      padding: 0 1rem;
      
      &-title {
        text-align: center;
        color: var(--main-color-accent);

        &-place {
          display: block;
          margin-top: 0.5rem;
        }

        &-dates {
          margin-top: 0.5rem;
          display: block;
        }
      }
    }
  }

  @include sm-mobile {
    .home-block {
      &-title { font-size: 1.5rem; }
    }
  }
</style>